module.exports = __webpack_public_path__ + "img/nosotros_somos_mezcla_brava.9a790559.png";